module.exports = __webpack_public_path__ + "static/img/Jade-Gresham.78c80b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jade-Gresham.jpg
// module id = MX+N
// module chunks = 0